// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1PGKD","tab":"ProcedureTabs_tab__2SmP4"};